module.exports = __webpack_public_path__ + "static/media/anc5kz.ab0b2221.pdf";